import { defineMessages } from "locales/defineMessages";

// Canonical labels for backend enums and shared actions. Look them up with
// t(`enum.role.${role}`) so every screen shows the same wording.
export default defineMessages({
  vi: {
    "enum.role.SYSTEM_ADMIN": "Quản trị hệ thống",
    "enum.role.MANAGER": "Quản lý trung tâm",
    "enum.role.TEACHER": "Quản lý lớp",
    "enum.role.TRAINER": "Huấn luyện viên",
    "enum.role.STUDENT": "Học viên",
    "enum.roleShort.TEACHER": "QLL",
    "enum.roleShort.TRAINER": "HLV",
    "enum.role.unknown": "Không rõ",

    "enum.classStatus.OPENING": "Đang mở",
    "enum.classStatus.ONGOING": "Đang diễn ra",
    "enum.classStatus.CLOSED": "Đã đóng",

    "enum.sessionStatus.SCHEDULED": "Đã lên lịch",
    "enum.sessionStatus.ACTIVE": "Đang diễn ra",
    "enum.sessionStatus.COMPLETED": "Đã kết thúc",
    "enum.sessionStatus.CANCELLED": "Đã hủy",
    "enum.sessionStatus.CLOSED": "Đã đóng",

    "enum.enrollmentStatus.ACTIVE": "Đang học",
    "enum.enrollmentStatus.RESERVED": "Bảo lưu",
    "enum.enrollmentStatus.COMPLETED": "Đã hoàn thành",

    "enum.leaveStatus.PENDING": "Chờ duyệt",
    "enum.leaveStatus.APPROVED": "Đã duyệt",
    "enum.leaveStatus.REJECTED": "Đã từ chối",

    "enum.reportStatus.DRAFT": "Bản nháp",
    "enum.reportStatus.SUBMITTED": "Đã gửi",

    "action.save": "Lưu",
    "action.saving": "Đang lưu...",
    "action.cancel": "Hủy",
    "action.close": "Đóng",
    "action.confirm": "Xác nhận",
    "action.delete": "Xóa",
    "action.edit": "Chỉnh sửa",
    "action.create": "Tạo mới",
    "action.add": "Thêm",
    "action.back": "Quay lại",
    "action.next": "Tiếp tục",
    "action.search": "Tìm kiếm",
    "action.retry": "Thử lại",
    "action.export": "Xuất file",
    "action.clearFilters": "Xóa bộ lọc",
    "action.viewDetail": "Xem chi tiết",

    "state.loading": "Đang tải...",
    "state.noData": "Không có dữ liệu",
    "state.loadFailed": "Không thể tải dữ liệu",
    "state.saveSuccess": "Đã lưu thành công",
    "state.saveFailed": "Lưu thất bại",
    "state.notUpdated": "Chưa cập nhật",

    "theme.switchToDark": "Chuyển sang giao diện tối",
    "theme.switchToLight": "Chuyển sang giao diện sáng",
  },
  en: {
    "enum.role.SYSTEM_ADMIN": "System admin",
    "enum.role.MANAGER": "Center manager",
    "enum.role.TEACHER": "Class manager",
    "enum.role.TRAINER": "Trainer",
    "enum.role.STUDENT": "Student",
    "enum.roleShort.TEACHER": "CM",
    "enum.roleShort.TRAINER": "Trainer",
    "enum.role.unknown": "Unknown",

    "enum.classStatus.OPENING": "Open",
    "enum.classStatus.ONGOING": "Ongoing",
    "enum.classStatus.CLOSED": "Closed",

    "enum.sessionStatus.SCHEDULED": "Scheduled",
    "enum.sessionStatus.ACTIVE": "In progress",
    "enum.sessionStatus.COMPLETED": "Completed",
    "enum.sessionStatus.CANCELLED": "Cancelled",
    "enum.sessionStatus.CLOSED": "Closed",

    "enum.enrollmentStatus.ACTIVE": "Active",
    "enum.enrollmentStatus.RESERVED": "On hold",
    "enum.enrollmentStatus.COMPLETED": "Completed",

    "enum.leaveStatus.PENDING": "Pending",
    "enum.leaveStatus.APPROVED": "Approved",
    "enum.leaveStatus.REJECTED": "Rejected",

    "enum.reportStatus.DRAFT": "Draft",
    "enum.reportStatus.SUBMITTED": "Submitted",

    "action.save": "Save",
    "action.saving": "Saving...",
    "action.cancel": "Cancel",
    "action.close": "Close",
    "action.confirm": "Confirm",
    "action.delete": "Delete",
    "action.edit": "Edit",
    "action.create": "Create",
    "action.add": "Add",
    "action.back": "Back",
    "action.next": "Continue",
    "action.search": "Search",
    "action.retry": "Retry",
    "action.export": "Export",
    "action.clearFilters": "Clear filters",
    "action.viewDetail": "View details",

    "state.loading": "Loading...",
    "state.noData": "No data",
    "state.loadFailed": "Failed to load data",
    "state.saveSuccess": "Saved successfully",
    "state.saveFailed": "Failed to save",
    "state.notUpdated": "Not updated",

    "theme.switchToDark": "Switch to dark mode",
    "theme.switchToLight": "Switch to light mode",
  },
});
